import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface PricingFieldsProps {
  priceMonthly: number;
  priceAnnual: number;
  priceLifetime: number;
  onPriceMonthlyChange: (value: number) => void;
  onPriceAnnualChange: (value: number) => void;
  onPriceLifetimeChange: (value: number) => void;
}

export function PricingFields({
  priceMonthly,
  priceAnnual,
  priceLifetime,
  onPriceMonthlyChange,
  onPriceAnnualChange,
  onPriceLifetimeChange,
}: PricingFieldsProps) {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="price-monthly">Preço Mensal (R$)</Label>
          <Input
            id="price-monthly"
            type="number"
            min="0"
            step="0.01"
            value={priceMonthly}
            onChange={(e) => onPriceMonthlyChange(parseFloat(e.target.value) || 0)}
            placeholder="0.00"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="price-annual">Preço Anual (R$)</Label>
          <Input
            id="price-annual"
            type="number"
            min="0"
            step="0.01"
            value={priceAnnual}
            onChange={(e) => onPriceAnnualChange(parseFloat(e.target.value) || 0)}
            placeholder="0.00"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="price-lifetime">Preço Vitalício (R$)</Label>
          <Input
            id="price-lifetime"
            type="number"
            min="0"
            step="0.01"
            value={priceLifetime}
            onChange={(e) => onPriceLifetimeChange(parseFloat(e.target.value) || 0)}
            placeholder="0.00"
          />
        </div>
      </div>
    </div>
  );
}
